<template>
  <div class="container-fluid">
    <div class="m-2">
      <div class="alert alert-primary text-center">
        <div class="h4">
        	<linkto :link="'/'"/>
          	Termékek lista
        </div>
      </div>
    </div>
  	<div class="row d-flex justify-content-center m-2">
  		<div class="col-12 col-sm-12 col-md-6 col-lg-4 text-center">
  			<router-link :to="'/product/new_product'" class="btn btn-lg btn-outline-primary">
  			    Új termék
  			</router-link>
  		</div>
  	</div>
    <div class="row d-flex mt-2 mb-2">
      <div class="col-1">#</div>
      <div class="col-2">Név</div>
      <div class="col-3">Leírás</div>
      <div class="col-1">Ár</div>
      <div class="col-2">Megjegyzés</div>
      <div class="col-1">Aktív</div>
      <div class="col-1">Módosít</div>
    </div>
    <div class="m-2 pb-4">
      <draggable v-model="products" group="" @start="drag=true" @end="drag=false">
          <div
              class="row d-flex pb-2"
              :class="[
                k % 2 == 0 ? 'bg--light' : ''
              ]"
              v-for="(v,k) in products"
              :key="k"
          >
              <div class="col-1">{{v.id}}</div>
              <div class="col-2">{{v.nev}}</div>
              <div class="col-3">{{v.leiras}}</div>
              <div class="col-1">{{v.ar}}</div>
              <div class="col-2">{{v.megj}}</div>
              <div class="col-1">
                  <span class="text-success" v-if="v.aktiv === 1">
                    <strong>OK</strong>
                  </span>
                  <span class="text-danger" v-if="v.aktiv === 0">
                    <strong>X</strong>
                  </span>
              </div>
              <div class="col-1">
                <router-link
                  :to="`/products/${v.id}`"
                >
                  Módosít
                </router-link>
              </div>
          </div>
      </draggable>
      <div class="row d-flex mb-3">
        <div class="col-12 text-center">
          <button
            class="btn btn-primary"
            @click.prevent="save"
          >
            Sorrend mentése
          </button>
        </div>
      </div>
    </div>
    <!--
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Név</th>
            <th scope="col">Leírás</th>
            <th scope="col">Ár</th>
            <th scope="col">Megjegyzés</th>
            <th scope="col">Aktív</th>
            <th scope="col">Módosít</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in products" :key="index">
            <td>{{item.id}}</td>            
            <td>{{item.nev}}</td>
            <td>{{item.leiras}}</td>
            <td>{{item.ar}}</td>
            <td>{{item.megj}}</td>
            <td>
                <span class="text-success" v-if="item.aktiv === 1">
                  <strong>OK</strong>
                </span>
                <span class="text-danger" v-if="item.aktiv === 0">
                  <strong>X</strong>
                </span>
            </td>
            <td>
              <router-link
                :to="`/products/${item.id}`"
              >
                Módosít
              </router-link>
            </td>
          </tr>
      </table>
    </div>-->
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'products',
  components: {
    draggable
  },
  data () {
    return {
      products: []
    }
  },
  mounted(){
    this.load()
  },
  methods: {
    load(){
      this.$Progress.start()
      this.req.post('/products/search')
        .then(res => {
        	this.products = res.data.products
          	this.$Progress.finish()
        })
        .catch(err => {
          console.log(err)
          this.$Progress.fail()
        })
    },

    save() {
      let arr = []
      for(let p in this.products) {
        arr.push({
          rendezes: p,
          id: this.products[p].id
        })
      }

      this.req.post('/products/rendezes',{
        arr: arr
      })
        .then(res => {
            this.$Progress.finish()
            toastr.success(res.data.text)
            this.load()
        })
        .catch(err => {
          console.log(err)
          toastr.error(err.response.data.text || 'mentés sikertelen')
          this.$Progress.fail()
        })
    }
  }
}
</script>

<style scoped>
.bg--light {
  background-color: #b9b9b9;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/products/products.vue